import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { variant } from 'styled-system';
import Box from '../Box';
import { get } from '../../styles/constant';
const flagSizeConfig = variant({
  prop: 'fit',
  variants: {
    large: {
      width: get('space.30')
    },
    small: {
      width: get('space.20')
    },
    medium: {
      width: get('space.26')
    }
  }
});
const variants = {
  flagSizeConfig
};
export const StyledCountryFlag = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), variants.flagSizeConfig);